var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_834_61701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3672 10.3242C21.3672 17.3242 12.3672 23.3242 12.3672 23.3242C12.3672 23.3242 3.36719 17.3242 3.36719 10.3242C3.36719 7.93727 4.3154 5.64808 6.00323 3.96026C7.69105 2.27243 9.98024 1.32422 12.3672 1.32422C14.7541 1.32422 17.0433 2.27243 18.7311 3.96026C20.419 5.64808 21.3672 7.93727 21.3672 10.3242Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3672 13.3242C14.024 13.3242 15.3672 11.9811 15.3672 10.3242C15.3672 8.66736 14.024 7.32422 12.3672 7.32422C10.7103 7.32422 9.36719 8.66736 9.36719 10.3242C9.36719 11.9811 10.7103 13.3242 12.3672 13.3242Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_834_61701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.367188 0.324219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMapPin);
export default __webpack_public_path__ + "static/media/header-map-pin.2c08dddf91b217b5803da73d4dd17fad.svg";
export { ForwardRef as ReactComponent };